// @ts-ignore
import md5Hash from 'md5';
import { Buffer } from 'buffer';

export const capitalize = (val: string, exclude = ['de']) => {
  return val
    .split(' ')
    .map((piece) => {
      const pieceInLowerCase = piece.toLowerCase();
      if (exclude.includes(piece.toLowerCase())) {
        return pieceInLowerCase.toLowerCase();
      }

      const firstChar = pieceInLowerCase.charAt(0).toUpperCase();
      return firstChar + pieceInLowerCase.slice(1);
    })
    .join(' ');
};

export const capitalizeFirstLetter = (val: string) => val.charAt(0).toUpperCase() + val.toLowerCase().slice(1);

export const onlyDigits = (val: string) => {
  const match = val.match(/\d/g);
  if (match) return match.join('');
  return val;
};

export const toE164BrazilPhone = (phone: string): string => {
  const digits = onlyDigits(phone);
  const localDigits = digits.length > 11 && digits.startsWith('55') ? digits.slice(2) : digits;
  return `+55${localDigits}`;
};

export const formatCellphone = (telefone: string, spaceInPrefix?: boolean) => {
  let regex;

  if (spaceInPrefix) {
    regex = /(\d{2})(\d)(\d{4})(\d{4})/;
  } else {
    regex = /(\d{2})(\d{4,5})(\d{4})/;
  }

  const match = telefone.match(regex);
  if (!match || match.length < 4) return telefone;

  if (spaceInPrefix) {
    return `(${match[1]}) ${match[2]} ${match[3]}-${match[4]}`;
  }
  return `(${match[1]}) ${match[2]}-${match[3]}`;
};

export const formatCpf = (cpf: string) => {
  const regex = /(\d{3})(\d{3})(\d{3})(\d{2})/;
  const match = cpf.match(regex);
  if (!match || match.length === 11) return cpf;
  return `${match[1]}.${match[2]}.${match[3]}-${match[4]}`;
};

export const encryptToMd5 = (message: string) => md5Hash(message);

export const extractLoginFromToken = (token: string) => {
  const decrypted = Buffer.from(token, 'base64').toString();
  return decrypted.split(':')[0];
};

export const firstLetterInLowerCase = (text: string) => {
  if (text.length === 0) return text;
  return text.charAt(0).toLowerCase() + text.slice(1);
};

export const removeAccentuation = (value: string): string => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const pluralIndicator = (value: string, indicator: string, condition: boolean): string => {
  if (!condition) return value;
  return `${value}${indicator}`;
};

export const checkIfStringHasWordWithTonicAccent = (value: string): boolean => {
  return /[áéíóúàèìòùâêîôûãõçÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÃÕÇ]/g.test(value || '');
};

export const isProfessionalIssuerDoctor = (professionalIssuer: string) => {
  return /(CFM|CRM)/gi.test(professionalIssuer);
};

export const formatCNS = (cns: string) => {
  if (!cns) return '';

  return [
    cns.substring(0, 3),
    cns.substring(3, 6),
    cns.substring(6, 9),
    cns.substring(9, 12),
    cns.substring(12, 15),
  ].join('.');
};

export const formatCEP = (cep: string) => {
  if (!cep) return '';

  return [cep.substring(0, 5), cep.substring(5, 8)].join('-');
};

export const formatSigtap = (cigtap: string) => {
  if (!cigtap) return '';

  return (
    [cigtap.substring(0, 2), cigtap.substring(2, 4), cigtap.substring(4, 6), cigtap.substring(6, 9)].join('.') +
    '-' +
    cigtap.substring(9, 10)
  );
};
